module.exports = __webpack_public_path__ + "static/media/15_l_kotli_23.7_64.72.ae362073.png";